var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("driver.batchRegistrationProblemItems"),
        visible: _vm.batchDrawer,
        top: "1vh",
        width: "630px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.batchDrawer = $event
        },
        close: function ($event) {
          return _vm.resetForm("ruleForm")
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "overflow-y": "auto", padding: "5px 10px" } },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "div",
                        { staticClass: "selectLabel" },
                        [
                          _c(
                            "el-select",
                            {
                              model: {
                                value: _vm.ruleForm.numberType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "numberType", $$v)
                                },
                                expression: "ruleForm.numberType",
                              },
                            },
                            [
                              _vm.activeName === "0"
                                ? _c("el-option", {
                                    key: "0",
                                    attrs: {
                                      label: _vm.$t("collectionCenter.Barcode"),
                                      value: 0,
                                    },
                                  })
                                : [
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.waybillNumber"
                                        ),
                                        value: 0,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "GlobalSetObj.ScanNumber"
                                        ),
                                        value: 1,
                                      },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "inputValue" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "GlobalSetObj.CanBeEnteredMultiple2000"
                              ),
                              rows: 2,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.inputValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "inputValue", $$v)
                              },
                              expression: "ruleForm.inputValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.problemReason"),
                            prop: "problemId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.changeSelectProblemReason },
                              model: {
                                value: _vm.ruleForm.problemId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "problemId", $$v)
                                },
                                expression: "ruleForm.problemId",
                              },
                            },
                            _vm._l(
                              _vm.causeProblemList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.dictDescribe,
                                    value: item.problemId,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isUploadingThree === false
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("scripting.damagedItems"),
                                prop: "damagedItemsType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.damagedItemsType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "damagedItemsType",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.damagedItemsType",
                                  },
                                },
                                _vm._l(
                                  _vm.damagedItemsTypeList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("GlobalSetObj.remark"),
                            prop: "problemReason",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 200,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              rows: 2,
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.problemReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "problemReason", $$v)
                              },
                              expression: "ruleForm.problemReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isUploadingThree
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.UploadPictures"),
                                prop: "problemImg",
                              },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "uploadRef",
                                  attrs: {
                                    "before-upload": _vm.beforeAvatarUpload,
                                    "file-list": _vm.imageList,
                                    "http-request": function (file) {
                                      return _vm.upLoad(file, 1)
                                    },
                                    limit: 3,
                                    "on-change": _vm.handleChangeFile,
                                    "on-exceed": _vm.handleExceed,
                                    "on-remove": _vm.handleDeleteImgRemove,
                                    action: "#",
                                    "list-type": "picture-card",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.problemImg,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "problemImg", $$v)
                                    },
                                    expression: "ruleForm.problemImg",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "problemImg" } },
                            [
                              _c("template", { slot: "label" }, [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "10px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("GlobalSetObj.UploadPictures")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        "font-weight": "normal",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "GlobalSetObj.uploadImageWithRequirement"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "flex-start" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        "before-upload": _vm.beforeAvatarUpload,
                                        "http-request": function (file) {
                                          return _vm.upLoad(file, 2)
                                        },
                                        "on-change": _vm.handleChangeFile,
                                        "on-remove": _vm.handleDeleteImgRemove,
                                        "show-file-list": false,
                                        action: "#",
                                      },
                                    },
                                    [
                                      _vm.imageList1
                                        ? _c(
                                            "div",
                                            { staticClass: "preview-box" },
                                            [
                                              _c("img", {
                                                staticClass: "avatar",
                                                attrs: { src: _vm.imageList1 },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-close delete-icon",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeImg(1)
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "upload-txt" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-plus avatar-uploader-icon",
                                                staticStyle: {
                                                  "margin-top": "20px",
                                                  "font-size": "18px",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "driver.packageLabel"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "driver.waybillClearlyVisible"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        "before-upload": _vm.beforeAvatarUpload,
                                        "http-request": function (file) {
                                          return _vm.upLoad(file, 3)
                                        },
                                        "on-change": _vm.handleChangeFile,
                                        "on-remove": _vm.handleDeleteImgRemove,
                                        "show-file-list": false,
                                        action: "#",
                                      },
                                    },
                                    [
                                      _vm.imageList2
                                        ? _c(
                                            "div",
                                            { staticClass: "preview-box" },
                                            [
                                              _c("img", {
                                                staticClass: "avatar",
                                                attrs: { src: _vm.imageList2 },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-close delete-icon",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeImg(2)
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "upload-txt" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-plus avatar-uploader-icon",
                                                staticStyle: {
                                                  "margin-top": "20px",
                                                  "font-size": "18px",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "driver.outerPackaging"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "driver.showCompleteOuterPackaging"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "avatar-uploader",
                                      attrs: {
                                        "before-upload": _vm.beforeAvatarUpload,
                                        "http-request": function (file) {
                                          return _vm.upLoad(file, 4)
                                        },
                                        "on-change": _vm.handleChangeFile,
                                        "on-remove": _vm.handleDeleteImgRemove,
                                        "show-file-list": false,
                                        action: "#",
                                      },
                                    },
                                    [
                                      _vm.imageList3
                                        ? _c(
                                            "div",
                                            { staticClass: "preview-box" },
                                            [
                                              _c("img", {
                                                staticClass: "avatar",
                                                attrs: { src: _vm.imageList3 },
                                              }),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-close delete-icon",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.removeImg(3)
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "upload-txt" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-plus avatar-uploader-icon",
                                                staticStyle: {
                                                  "margin-top": "20px",
                                                  "font-size": "18px",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "driver.internalDamage"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    "line-height": "20px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "driver.damageDetailCloseUp"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                  _vm.problemTotal > 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "labelTitle" }, [
                          _vm._v(
                            _vm._s(_vm.$t("driver.latestExecutionProgress"))
                          ),
                        ]),
                        _c("div", { staticClass: "flx-between" }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("driver.executionTotal")) +
                                ": " +
                                _vm._s(_vm.problemTotal || 0)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("driver.remaining")) +
                                ": " +
                                _vm._s(_vm.remainingNumber || 0)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("driver.successCount")) +
                                ": " +
                                _vm._s(_vm.successNumber || 0)
                            ),
                          ]),
                          _c("div", [
                            _vm._v(
                              " " + _vm._s(_vm.$t("driver.failureCount")) + ": "
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.failureNumber || 0)),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.failureNumber > 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "labelTitle" }, [
                          _vm._v(_vm._s(_vm.$t("driver.failedNumbers"))),
                        ]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-height": "230px",
                              width: "100%",
                              overflow: "auto",
                              "font-size": "14px",
                            },
                          },
                          _vm._l(_vm.failureDetails, function (item, index) {
                            return _c("div", { key: index }, [
                              _c("span", [_vm._v(_vm._s(index + 1) + ". ")]),
                              _c("span", [
                                _vm._v(_vm._s(item.orderNumber) + ", "),
                              ]),
                              _c("span", [_vm._v(_vm._s(item.failureReason))]),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _vm.problemTotal > 0
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { margin: "10px 0" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("el-progress", {
                            attrs: {
                              color: _vm.customColorMethod,
                              percentage: _vm.percentage,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.remainingNumber === 0 && _vm.problemTotal > 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.resetForm("ruleForm")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("GlobalSetObj.Close")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticStyle: { "text-align": "right" } },
                          [
                            _vm.statusBtn
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "small", type: "warning" },
                                    on: { click: _vm.stopTimer },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showBtn
                                          ? _vm.$t("roleManage.cancel")
                                          : _vm.$t("GlobalSetObj.Canceled")
                                      ) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showBtn
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: _vm.loadingBtn,
                                      loading: _vm.loadingBtn1,
                                      size: "small",
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.submitForm("ruleForm")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.loadingBtn1
                                          ? _vm.$t("driver.executing")
                                          : _vm.$t("roleManage.confirm")
                                      ) + " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.resetForm("ruleForm")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("GlobalSetObj.Close")) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }